// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/EnumValue.yaml
// Generated: 2025-11-13T19:25:50.900Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateEnumValue, UpdateEnumValue, EnumValue } from '@/types/core/EnumValue';

/**
 * EnumValue Service
 * CRUD operations for EnumValue via the ABP API.
 */
export const enumValueService = new EntityService<EnumValue, CreateEnumValue, UpdateEnumValue>(
  '/api/core/enumvalue',
  'EnumValue',
);
